export const TeamChatFileMessageTestIds = {
  IMAGE_LINK: 'team-chat.file-image-link',
  FILE_LINK: 'team-chat.file-name-link',
};
